// extracted by mini-css-extract-plugin
module.exports = {"locationContent":"_1NoR7Mk6","locationHeader":"_3V3GlBkq","nameContent":"_4qmzkd1v","nameHeader":"YooOlNm0","emailContent":"_1RCY77eW","emailHeader":"_1BJyHija","leadsTitle":"vCp2fiSA","createdAtContent":"_1-8BWDXn","createdAtHeader":"_26p6qzpg"};
    if(module.hot) {
      // 1754515032199
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  